import React from "react";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast"; // Componente de notificaciones
import { Button } from "primereact/button";

const ImageUpload = (props) => {
  const maxSizeImage = 1000000;
  const toast = React.createRef(); // referencia para el componente Toast

  const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    try {
      const file = event.files[0];
      if (file.size > maxSizeImage) {
        throw new Error("La imagen execede el tamaño máximo");
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        props.setImage(reader.result);
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Imagen subida correctamente",
        });
      };
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
      });
    }
  };

  const itemTemplate = (file, props) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>

        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };

  const onTemplateRemove = (file, callback) => {
    callback();
  };

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <span
          style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
          className="my-5"
        >
          {props.emptyText}
        </span>
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />

      <FileUpload
        name="image"
        accept="image/*"
        maxFileSize={maxSizeImage}
        uploadLabel="Subir"
        chooseLabel={props.chooseLabel}
        cancelLabel="Cancelar"
        customUpload
        uploadHandler={customBase64Uploader}
        auto={props.auto}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
      />
    </div>
  );
};

export default ImageUpload;
